import ApiService from '../apiservice'

export default class LiminarService extends ApiService {
  constructor() {
    super('/liminar')
  }

  cadastrar(liminar) {
    return this.post('/',liminar);
  }

  listar(processo) {
    return this.get(`/consulta-por-processo/${processo}`);
  }

  alterar(liminar) {
    return this.put('/',liminar);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }

  consultar(codigo) {
    return this.get(`/por-codigo/${codigo}`);
  }
}